import { passiveListenerSupported } from '../utility/event';
import { select } from '../utility/dom';
export default (buttonElement, options = { panelActiveClassname: 'is-shown', blockBodyScroll: true, callback: null }) => {
    const panelId = buttonElement.getAttribute('aria-controls');
    const panel = select(`#${panelId}`).firstOrFail();
    const closeButtonId = buttonElement.dataset.closeButton;
    const closeButton = closeButtonId && select(`#${closeButtonId}`).first;
    const { panelActiveClassname = 'is-shown', blockBodyScroll = true, callback = null } = options;
    let isShown = panel.classList.contains(panelActiveClassname);
    const passiveListener = passiveListenerSupported();
    const _open = () => {
        isShown = true;
        panel.classList.add(panelActiveClassname);
        buttonElement.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        blockBodyScroll && _lockBodyScroll();
        callback && callback('open');
    };
    const _close = () => {
        isShown = false;
        panel.classList.remove(panelActiveClassname);
        panel.setAttribute('aria-hidden', 'true');
        buttonElement.setAttribute('aria-expanded', 'false');
        blockBodyScroll && _unlockBodyScroll();
        callback && callback('close');
    };
    let _bodyScrollPosition = { x: 0, y: 0 };
    const _lockBodyScroll = () => {
        _bodyScrollPosition = { x: window.pageXOffset, y: window.pageYOffset };
        document.body.style.overflow = 'hidden';
    };
    const _unlockBodyScroll = () => {
        document.body.style.overflow = null;
        window.scrollTo(_bodyScrollPosition.x, _bodyScrollPosition.y);
    };
    buttonElement.addEventListener('click', () => {
        isShown ? _close() : _open();
    });
    if (closeButton) {
        closeButton.addEventListener('click', () => {
            isShown && _close();
        });
    }
    document.body.addEventListener('click', (event) => {
        if (!isShown)
            return;
        const handler = event.target;
        if (handler === buttonElement || handler.closest(`#${panelId}`)) {
            return;
        }
        _close();
    }, passiveListener ? { passive: true } : false);
    document.body.addEventListener('keyup', event => {
        if (event.key === 'Escape') {
            isShown && _close();
        }
    });
};
